import React, { Fragment } from 'react'
import Props from 'prop-types'
import { Link } from 'gatsby'

import ScrollLink from 'components/ScrollLink'
import { Li } from './styled'

const MenuItems = ({ isFooterNav, onScrollClick }) => (
  <Fragment>
    <Li>
      <ScrollLink onScrollClick={onScrollClick} to="#about">
        About
      </ScrollLink>
    </Li>
    <Li>
      <Link to="/qa?web">Q&amp;A</Link>
    </Li>
    <Li>
      <ScrollLink onScrollClick={onScrollClick} to="#contact">
        Contact
      </ScrollLink>
    </Li>
    <Li mobileOnly={!isFooterNav}>
      <Link to="/privacy-policy?web">Privacy Policy</Link>
    </Li>
    <Li mobileOnly={!isFooterNav}>
      <Link to="/terms-of-use?web">Terms of Use</Link>
    </Li>
  </Fragment>
)

MenuItems.propTypes = {
  isFooterNav: Props.bool,
  onScrollClick: Props.func,
}

MenuItems.defaultProps = {
  isFooterNav: false,
  onScrollClick: () => null,
}

export default MenuItems
